import { useState } from 'react'
import { JsonViewer } from '../../library/JsonViewer/JsonViewer'
import type { MatesDebugData } from '../MatesDebug'
import { Button } from '@merels/ui'

export function RoomDebug({
  data,
  onFlushMates,
  onEndGame,
}: {
  data: MatesDebugData
  onFlushMates?: () => void
  onEndGame?: () => void
}) {
  const [activeTab, setActiveTab] = useState<'room' | 'local' | 'game'>('room')

  const tabClass = (tab: string) =>
    `px-3 py-1 text-xs font-semibold rounded-md border transition-all ${
      activeTab === tab
        ? 'bg-accent text-white border-accent'
        : 'bg-muted-bg text-muted border-basic hover:text-primary hover:border-accent/40'
    }`

  return (
    <div className="flex flex-col flex-1 h-full min-h-0">
      {/* Sub tabs navigation */}
      <div className="flex gap-2 p-2 border-b border-basic/30 bg-muted-bg/10 flex-shrink-0">
        <button className={tabClass('room')} onClick={() => setActiveTab('room')}>
          Room Info
        </button>
        <button className={tabClass('local')} onClick={() => setActiveTab('local')}>
          Local Mates
        </button>
        <button className={tabClass('game')} onClick={() => setActiveTab('game')}>
          Game Info
        </button>
      </div>

      <div className="flex-1 min-h-0 overflow-auto p-3 space-y-3">
        {activeTab === 'local' && (
          <>
            <JsonViewer title="Local mates (this client)" data={data.localMates} />
            <JsonViewer title="Controller mates" data={data.controllerMates} />
          </>
        )}

        {activeTab === 'room' && (
          <>
            {onFlushMates && (
              <div className="flex gap-2 mb-2">
                <Button variant="destructive" size="sm" onClick={onFlushMates}>
                  Flush mates (debug)
                </Button>
              </div>
            )}
            <JsonViewer title="Room" data={data.roomInfo} />
            <JsonViewer title="Room mates" data={data.roomMates} />
          </>
        )}

        {activeTab === 'game' && (
          <>
            {onEndGame && data.activeGame && (
              <div className="flex gap-2 mb-2">
                <Button
                  variant="destructive"
                  size="sm"
                  onClick={() => {
                    if (window.confirm('End the game in this room?')) onEndGame()
                  }}
                >
                  End game (debug)
                </Button>
              </div>
            )}
            <JsonViewer title="Active game" data={data.activeGame} />
            <JsonViewer title="Assignment preferences (mateId → gamePlayerId)" data={data.assignmentPreferences} />
            <JsonViewer title="Derived playerAssignment (players/observers)" data={data.playerAssignment} />
          </>
        )}
      </div>
    </div>
  )
}
